import { StatusCodes } from "http-status-codes";
import { request } from "../api";
import { headers } from "../../../config/config";
import { MESSAGE } from "../../../constants/api/message";
import { AUTHORIZATION } from "../../../constants/api/auth";

const { get } = request;
const { Authorization, Bearer } = AUTHORIZATION;

export type FindEmployeeQueryTypes = {
	employee_SSN: string;
	group_number: number;
};

const initialRoute = "member";

export const getMembersByEmployeeSSN = async (findEmployeeQuery: FindEmployeeQueryTypes) => {
	try {
		// console.log("findEmployeeQuery", findEmployeeQuery);
		const endpoint = `${initialRoute}/get-members-by-employee-ssn`;
		const token = localStorage.getItem("@jwt");
		const response = await get(
			endpoint,
			{
				...headers,
				[Authorization]: `${Bearer} ${token}`
			},
			findEmployeeQuery
		);
		// console.log("resonseceheckinig---->>>", response);
		if (response) {
			const {
				data: { message }
			} = response;
			if (message === MESSAGE.get.succ) {
				const {
					data: { result }
				} = response;
				return result;
			}
		}
		throw new Error();
	} catch (error: any) {
		if (error.response.status === StatusCodes.BAD_REQUEST) {
			const { message } = error.response.data;

			alert(message);
		} else if (error.response.status === StatusCodes.UNAUTHORIZED) {
			const { message } = error.response.data;

			alert(message);
		} else {
			throw error;
		}
	}
};
//testing git
